import script from "./VirtualizedEzTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./VirtualizedEzTable.vue?vue&type=script&setup=true&lang=ts"

import "./VirtualizedEzTable.vue?vue&type=style&index=0&id=b114a918&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b114a918"]])

export default __exports__